// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconHandMoneyPath = 'M18 0v8H2V0h16Zm-2 6H4V2h12v4ZM9.519 18a7.995 7.995 0 0 1-5.864-2.567 8.558 8.558 0 0 1-.758-.946l.413-.536.001-.001a5.038 5.038 0 0 1 3.961-1.96h5.703A3.996 3.996 0 0 1 9.519 14h-1v2h1c2.635 0 4.939-1.691 5.744-4.244.019-.067.054-.142.114-.243l.009-.016c.182-.315.482-.507.823-.507l1.247.01c-.493 3.94-3.865 7-7.937 7Zm6.69-9c-.856 0-1.644.365-2.2 1H7.272a7.043 7.043 0 0 0-5.547 2.731L.48 14.348l.331.579c.374.652.836 1.278 1.373 1.861A10.002 10.002 0 0 0 9.519 20c5.514 0 10-4.486 10-10V9h-3.31ZM10 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z';
var IconHandMoney = baseIcon('IconHandMoney', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconHandMoneyPath
});
export default IconHandMoney;
//# sourceMappingURL=index.js.map